import { SEARCH_ROUTES } from '../shared/utils/routes'
import createAppRouter from './create_router'

const searchRouter = createAppRouter(SEARCH_ROUTES, {
  redirect: true,
  history: true,
})

export default searchRouter
